var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPerimeterSeating = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 8.1C20.2 8.70751 19.7075 9.2 19.1 9.2C18.4925 9.2 18 8.70751 18 8.1C18 7.49249 18.4925 7 19.1 7C19.7075 7 20.2 7.49249 20.2 8.1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 12.1C20.2 12.7075 19.7075 13.2 19.1 13.2C18.4925 13.2 18 12.7075 18 12.1C18 11.4925 18.4925 11 19.1 11C19.7075 11 20.2 11.4925 20.2 12.1Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1 17.2C19.7075 17.2 20.2 16.7075 20.2 16.1C20.2 15.4925 19.7075 15 19.1 15C18.4925 15 18 15.4925 18 16.1C18 16.7075 18.4925 17.2 19.1 17.2Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1 9.2C5.70751 9.2 6.2 8.70751 6.2 8.1C6.2 7.49249 5.70751 7 5.1 7C4.49249 7 4 7.49249 4 8.1C4 8.70751 4.49249 9.2 5.1 9.2Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1 6.2C15.4925 6.2 15 5.70751 15 5.1C15 4.49249 15.4925 4 16.1 4C16.7075 4 17.2 4.49249 17.2 5.1C17.2 5.70751 16.7075 6.2 16.1 6.2Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1 6.2C11.4925 6.2 11 5.70751 11 5.1C11 4.49249 11.4925 4 12.1 4C12.7075 4 13.2 4.49249 13.2 5.1C13.2 5.70751 12.7075 6.2 12.1 6.2Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.1C7 5.70751 7.49249 6.2 8.1 6.2C8.70751 6.2 9.2 5.70751 9.2 5.1C9.2 4.49249 8.70751 4 8.1 4C7.49249 4 7 4.49249 7 5.1Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1 13.2C5.70751 13.2 6.2 12.7075 6.2 12.1C6.2 11.4925 5.70751 11 5.1 11C4.49249 11 4 11.4925 4 12.1C4 12.7075 4.49249 13.2 5.1 13.2Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1 20.2C15.4925 20.2 15 19.7075 15 19.1C15 18.4925 15.4925 18 16.1 18C16.7075 18 17.2 18.4925 17.2 19.1C17.2 19.7075 16.7075 20.2 16.1 20.2Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1 20.2C11.4925 20.2 11 19.7075 11 19.1C11 18.4925 11.4925 18 12.1 18C12.7075 18 13.2 18.4925 13.2 19.1C13.2 19.7075 12.7075 20.2 12.1 20.2Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19.1C7 19.7075 7.49249 20.2 8.1 20.2C8.70751 20.2 9.2 19.7075 9.2 19.1C9.2 18.4925 8.70751 18 8.1 18C7.49249 18 7 18.4925 7 19.1Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1 17.2C5.70751 17.2 6.2 16.7075 6.2 16.1C6.2 15.4925 5.70751 15 5.1 15C4.49249 15 4 15.4925 4 16.1C4 16.7075 4.49249 17.2 5.1 17.2Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 2C23 1.44772 22.5523 1 22 1H2C1.44772 1 1 1.44772 1 2V22C1 22.5523 1.44772 23 2 23H22C22.5523 23 23 22.5523 23 22V2ZM3 3H21V21H3V3Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPerimeterSeating);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconPerimeterSeating.58200ff66038355ac42f8c2ab76cd9d2.svg";